var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f5f9ed;\n      }\n\n      .cls-4 {\n        font-family: Poppins-SemiBold, Poppins;\n        font-size: 13.9px;\n        font-weight: 600;\n        isolation: isolate;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #6db344;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(1.2 86.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Spring Boot")), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.5,58.7h0s.2,0,.2.2h0l-.4-.4v.2ZM65.7,7.1c-.8,2.1-2,4.1-3.4,5.9C50.1.4,30.1.1,17.5,12.2c-12.5,12.2-12.9,32.2-.8,44.8v.2c.5.4.9.7,1.3,1.1l.4.4h0s0-.2-.2-.2h0s0-.2,0-.2c0,0,0-.2,0-.2v-.2h0v-1.1h0v-.3c0-.2,0-.4.3-.6,0,0,.2-.3.3-.4.9-1.2,2.6-1.3,3.8-.4,1.1.9,1.3,2.6.4,3.8h0c0,0,0,.2-.2.2,0,0,0,0-.2.2,0,0,0,0-.2,0-.4.3-1,.4-1.5.4s-.2,0-.2,0h-.2c-.3,0-.6-.2-.9-.3,0,0,0,0-.2,0h0l.3.2c13.3,11.2,33.3,9.5,44.6-3.8,4.3-5.1,6.9-11.5,7.4-18.2.9-7.9-1.5-18.1-5.5-30.3l-.3-.2ZM65.5,49.2c-7.8,10.4-24.5,6.9-35.2,7.4,0,0-1.5,0-3.2.3h-.7s.7-.3,1.6-.7c7.5-2.6,11-3.1,15.6-5.5,8.6-4.4,17.1-14,18.8-23.9-3.3,9.5-13.2,17.8-22.2,21.1-.4.2-.9.3-1.4.5-.2,0-.5.2-.7.2s-.3,0-.4,0c-.2,0-.4,0-.6.2-.9.3-1.9.6-2.9.8h-.5c-3.2,1-6.5,1.7-8.6,2.2h-.5c-.3,0-.6,0-.9.2h-.2c-.5,0-.8.2-.8.2l-.5-.3c-7.6-3.7-7.8-20.2,6-25.5,6.1-2.4,11.8-1,18.4-2.6,7-1.6,15.1-6.9,18.4-13.7,3.7,11,8.1,28.2,0,38.7l.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.5,58.7h0s.2,0,.2.2h0l-.4-.4v.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBoot);
export default __webpack_public_path__ + "static/media/Spring Boot.6c80bd99d3146c42f6439386304f522f.svg";
export { ForwardRef as ReactComponent };